import request from '@/utils/request'

export function fetchMenus() {
  return request({
    url: '/menus',
    method: 'get'
  })
}
